export const types = {
	SET_APPDATA: 'APPDATA/SET',
};

export const initialState = {
	UserSlpCode: null,
	UserEmpID: null,
	UserID: null,
	UserGroup: null,
	UserName: '',
	UserInitials: '',
	DefaultWhs: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case types.SET_APPDATA:
			return { ...state, ...action.data };
		default:
			return state;
	}
}

export const actions = {
	setAppData: (data) => ({ type: types.SET_APPDATA, data }),
};